import { connect } from 'react-redux';

import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

import { AppState } from '../../../app/state/AppState';
import { MapStateToProps } from '../../../app/utils/ConnectUtils';
import { PageHeaderMenus, PageHeaderMenusStateProps } from './PageHeaderMenus';


const mapStateToProps: MapStateToProps<PageHeaderMenusStateProps> = (state: AppState): PageHeaderMenusStateProps => ({
  inServerArea: NavLocationSelectors.inServerArea(state),
  inSiteArea: NavLocationSelectors.inSiteArea(state),
  inSiteContentArea: NavLocationSelectors.inSiteContentArea(state),
  siteUrls: siteUrlsSelector(state),
});

export const ConnectedPageHeaderMenus = connect(mapStateToProps)(PageHeaderMenus);
